class CustomMessageApi {
    constructor(DoclrHttp, praktijkContext) {
        'ngInject';

        this.praktijkContext = praktijkContext;
        this.DoclrHttp = DoclrHttp;
    }

    create(newPersonNotification) {
        return this.DoclrHttp.post(this.getUniqueUrl(newPersonNotification.personId), newPersonNotification);
    }

    findAll(personId) {
        return this.DoclrHttp.get(this.getListUrl(personId));
    }

    getListUrl(personId) {
        return `/apiv0/party/${this.praktijkContext.id}/patienten/${personId}/notifications`;
    }

    getUniqueUrl(personId) {
        return `/apiv0/party/${this.praktijkContext.id}/patienten/${personId}/notify`;
    }

}

(function () {
    'use strict';

    angular.module('doclr.customMessage')
        .service('CustomMessageApi', CustomMessageApi)
})();